module.exports = __webpack_public_path__ + "img/logo-gestionale-motori.5ac76dda.svg";